"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        chartContainer: {
            height: 200,
            paddingBottom: 2,
        },
        loadingContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
        },
        textAlignCenter: {
            textAlign: 'center',
        },
        bold: {
            fontWeight: 'bold',
        },
        colorBox: {
            width: 10,
            height: 10,
            float: 'left',
            marginRight: 5,
        },
        skeletonBar: {
            marginLeft: 1,
            marginRight: 1,
        },
    });
});
